module.exports = __webpack_public_path__ + "6aa6d758c4bf9e09660b03ee677bc770.pdf";